export default __webpack_public_path__ + "static/media/search.a8d94ca1.svg";